import React from "react";
import "components/auth/onboarding.css";
import "components/auth/common/common.css";
import SectionTitle from "../SectionTitle";
import { iFromErrors, iProfileInfoForm } from "components/auth/common/types";
import LoginInput from "components/auth/common/LoginInput";
import ProfilePicturePicker from "components/common/profilePicture/ProfilePicturePicker";

interface ProfileInformationProps {
  handleChange: (prop: string) => (value: string) => void;
  data: iProfileInfoForm;
  formErrors: iFromErrors;
}

const cssPrefix = "onboarding-";
const ProfileInformation: React.FC<ProfileInformationProps> = ({
  data,
  handleChange,
  formErrors,
}) => {
  return (
    <div className={cssPrefix + "section-container"}>
      <SectionTitle label="Personal Information" />
      <div className={cssPrefix + "horizontal-input-container"}>
        <LoginInput
          label="Office Contact First Name"
          value={data?.firstName}
          name={"firstName"}
          onChange={handleChange}
          type="firstName"
          placeholder="Enter First Name"
          helperText={formErrors.firstName}
        />
        <LoginInput
          label="Office Contact Last Name"
          value={data?.lastName}
          name={"lastName"}
          onChange={handleChange}
          type="lastName"
          placeholder="Enter Last Name"
          helperText={formErrors.lastName}
        />
      </div>
      <ProfilePicturePicker data={data} handleChange={handleChange} formErrors={formErrors} />
    </div>
  );
};

export default ProfileInformation;
